import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/Home/Home";
import HowItWorks from "../pages/HowItWorks/HowItWorks";
import Intermediaries from "../pages/Intermediaries/Intermediaries";
import AboutUs from "../pages/AboutUs/AboutUs";
import Careers from "../pages/Careers/Careers";
import ContactUs from "../pages/ContactUs/ContactUs";
import Terms from "../pages/Terms/Terms";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import Compliance from "../pages/Compliance/Compliance";
import FAQ from "../pages/FAQ/FAQ";
import CareerDetail from "../pages/CareerDetail/CareerDetail";
import NotFound from "../pages/NotFound/NotFound";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Redirect root to home */}
      <Route path="/" element={<Navigate to="/home" replace />} />

      {/* Pages */}
      <Route path="/home" element={<Home />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/intermediaries" element={<Intermediaries />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/compliance" element={<Compliance />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/career-detail" element={<CareerDetail />}/>
      <Route
  path="*"
  element={<NotFound />}
/>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export default AppRoutes;